import { render, staticRenderFns } from "./HandicapChannelData.vue?vue&type=template&id=749cb434&scoped=true"
import script from "./HandicapChannelData.vue?vue&type=script&lang=js"
export * from "./HandicapChannelData.vue?vue&type=script&lang=js"
import style0 from "./HandicapChannelData.vue?vue&type=style&index=0&id=749cb434&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749cb434",
  null
  
)

export default component.exports